import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ArrowPrev from "../../../src/assets/images/arrow-prev.svg";
import ArrowNext from "../../../src/assets/images/arrow-next.svg";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowPrev}
      className={className}
      style={{ ...style }}
      onClick={onClick}
      alt="ArrowPrev"
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowNext}
      className={className}
      style={{ ...style }}
      onClick={onClick}
      alt="ArrowNext"
    />
  );
}

export default function Vantagens(props) {
  const dotsData = [
    { id: 1, text: "Acesse os principais streamings em um só lugar" },
    { id: 2, text: "Economize nas suas assinaturas" },
    { id: 3, text: "Novos filmes, séries e outros conteúdos todos os dias" },
    { id: 4, text: "Só por aqui você confere UOL originais" },
    { id: 5, text: "Perfil infantil: defina o que as crianças podem assistir" },
    { id: 6, text: "Sem compromisso, cancele quando quiser" },
    { id: 7, text: "Crie até 4 perfis sem custos adicionais" },
    { id: 8, text: "Assista em até 2 telas ao mesmo tempo" },
  ];

  const groupedData = [];
  for (let i = 0; i < dotsData.length; i += 4) {
    groupedData.push(dotsData.slice(i, i + 4)); // Agrupa 4 dots por slide
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  return (
    <Section>
      <Title>Aproveite as vantagens</Title>
      <Subtitle>O streaming que completa a sua diversão</Subtitle>
      <Container>
        <Image src="https://imguol.com.br/p/pp/uol-play/nova-pv/vantagens/arte-devices-greys.png" alt="logo" />
        <DotsDiv>
          {dotsData.map(({ id, text }) => (
            <Dot key={id}>
              <DotNumber>{id}</DotNumber>
              <DotText>{text}</DotText>
            </Dot>
          ))}
        </DotsDiv>
      </Container>

      {/* Slider para Mobile */}
      <MobileSlider {...settings}>
        {groupedData.map((group, index) => (
          <SlideWrapper key={index}>
            {group.map(({ id, text }) => (
              <Dot key={id}>
                <DotNumber>{id}</DotNumber>
                <DotText>{text}</DotText>
              </Dot>
            ))}
          </SlideWrapper>
        ))}
      </MobileSlider>
    </Section>
  );
}

const Section = styled.div`
  padding: 60px;
  background-image: url("https://imguol.com.br/p/pp/uol-play/nova-pv/vantagens/bg.png");
  background-size: cover;

  @media (max-width: 1160px) {
    background-color: #3256e2;
    background-image: url("https://imguol.com.br/p/pp/uol-play/nova-pv/vantagens/bg_art.svg");
    padding: 60px 16px;
  }
`;

const Title = styled.h4`
  font-size: 32px;
  color: white;
  font-weight: 600;
  text-align: center;
  padding-bottom: 10px;

  @media (max-width: 1160px) {
    font-size: 28px;
  }
`;

const Subtitle = styled.h5`
  font-size: 18px;
  color: white;
  font-weight: 300;
  text-align: center;
  padding-bottom: 70px;

  @media (max-width: 1160px) {
    font-size: 16px;
    padding-bottom: 40px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 1100px;
  margin: auto;
  @media (max-width: 1160px) {
    display: none;
  }
`;

const Image = styled.img`
  height: 335px;
  width: 756px;
  margin: auto;
`;

const DotsDiv = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  max-width: 100%;
  margin: 20px auto;
`;

const Dot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 230px;

  @media (max-width: 1160px) {
    width: 150px;
  }

  /* @media (max-width: 425px) {
    width: 120px;
  } */
`;

const DotNumber = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: center;
  background: linear-gradient(142deg, #ff6c00, #ffce00);
  color: white;
  font-size: 32px;
  font-weight: bold;
  text-shadow: 0px 1px 1px #00000080;
`;

const DotText = styled.p`
  font-size: 16px;
  color: white;
  margin-top: 8px;
  padding: 0 10px;
  text-align: center;
`;

const MobileSlider = styled(Slider)`
  display: none;

  @media (max-width: 1160px) {
    display: block;
    width: 350px;
    margin: 0 auto;

    .slick-prev,
    .slick-next {
      color: #ff6c00;
    }

    .slick-prev {
      width: 40px;
      height: 40px;
    }

    .slick-next {
      width: 40px;
      height: 40px;
    }

    .slick-slide > div {
      display: flex !important;
      justify-content: center;
      align-items: center;
    }
  }

  @media (max-width: 425px) {
    width: 320px;
  }

`;

const SlideWrapper = styled.div`
  display: grid !important;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 20px;
  justify-items: center;
  align-items: flex-start;
  height: auto;

  @media (max-width: 425px) {
    column-gap: 12px;
    width: 320px;
  }
`;
